
import { provideAuth } from '@/plugins/Auth';

export default {
  setup() {
    provideAuth();
  },
};
